import { bl_fi_my_einvoice_tin_update_request_queue_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class MyEInvoiceTinUpdateRequestQueueContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_tin_update_request_queue: bl_fi_my_einvoice_tin_update_request_queue_RowClass = new bl_fi_my_einvoice_tin_update_request_queue_RowClass();
}